import React from 'react';
import { connect } from 'react-redux';
import { deleteCalendarSourceById, getCalendarSourceIcalsByPropertyId } from '../../../entities/calendar-source/actions';
import { calendarSourcesForProperty } from '../../../entities/calendar-source/selectors';
import { IThunkDispatch } from '../../../store/middleware';
import { IState } from '../../../store/reducer';
import { CalendarSyncComponent, ICalendarSyncProps } from './CalendarSync';

const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
	getIcalCalendarSources: (propertyId: string | number) => dispatch(getCalendarSourceIcalsByPropertyId(propertyId)),
	deleteCalendarSource: (propertyId: string | number, calendarSourceId: number) =>
		dispatch(deleteCalendarSourceById(propertyId, calendarSourceId))
});

const mapStateToProps = (state: IState, ownProps: ICalendarSyncProps) => {
	const calendarSources = calendarSourcesForProperty(ownProps.propertyId, state);
	return { calendarSources };
};

const CalendarSyncContainer = (props: { propertyId: number | string } & Omit<ICalendarSyncProps, 'propertyId'>) => {
	const { propertyId, calendarSources, getIcalCalendarSources, deleteCalendarSource } = props;

	if (!calendarSources || !calendarSources.length)
		getIcalCalendarSources(propertyId);

	return <CalendarSyncComponent
		propertyId={propertyId}
		calendarSources={calendarSources}
		getIcalCalendarSources={getIcalCalendarSources}
		deleteCalendarSource={deleteCalendarSource}
	/>;
};

export const CalendarSync: React.ComponentType<{ propertyId: number | string }> =
	connect(mapStateToProps, mapDispatchToProps)(CalendarSyncContainer);
